module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-abstract-balmoral-1.3ad001cd.jpg";